import { Component, Input } from '@angular/core';
import { ApiImpact } from '@tytapp/api';

@Component({
  selector: 'tyt-company-impact-item',
  templateUrl: './company-impact-item.component.html',
  styleUrls: ['./company-impact-item.component.scss']
})
export class CompanyImpactItemComponent {

  @Input()
  impact: ApiImpact

  constructor() { }

}
